// Poll a backup/restore job's progress. Returns the snapshot, or null when the
// job isn't registered yet (the streaming GET creates it a beat after the client
// gets the token) or has already been swept — the caller keeps polling.
import { api } from './api.js';

export async function getProgress(token) {
  try {
    return await api.get(`/api/progress/${token}`);
  } catch (e) {
    if (e?.status === 404) return null;
    throw e;
  }
}
